<div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start center"
    fxLayoutGap="30px"
>
    <div style="min-width: 150px">
        <img
            *ngIf="fotoPerfil"
            [src]="fotoPerfil"
            alt=""
            class="avatar-imagen"
        />
        <div
            style="text-align: center"
            *ngIf="
                _menuUsuarioSrvc.esSupervisor() &&
                !contratista.fechaTermino &&
                !esModal
            "
        >
            <mat-list-item>
                <p matLine>
                    <mat-slide-toggle
                        #checkActivacion
                        checked
                        (change)="toggleActivacion($event)"
                        >Eliminar
                    </mat-slide-toggle>
                </p>
            </mat-list-item>
        </div>
        <p
            style="text-align: center"
            class="red-500"
            *ngIf="_menuUsuarioSrvc.esSupervisor() && eliminado"
        >
            (Eliminado)
        </p>
    </div>
    <div>
        <mat-list>
            <mat-list-item>
                <h3 matLine>Nombre</h3>
                <p matLine>
                    <span class="text-bold"
                        >{{ contratista?.nombres }}, {{ contratista?.apellidos }}
                    </span>

                    <button
                        *ngIf="_menuUsuarioSrvc.esSupervisor() && !eliminado"
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="editar()"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </p>
                <span matLine class="secondary-text">{{
                    contratista?.rut
                }}</span>
            </mat-list-item>

            <!-- mat-list-item>
                <h3 matLine>Dirección</h3>
                <p matLine>
                    <span class="secondary-text"></span>
                </p>
            </mat-list-item>

            <mat-list-item>
                <h3 matLine>Teléfono</h3>
                <p matLine>
                    <span class="secondary-text"></span>
                </p>
            </mat-list-item -->

            <mat-list-item>
                <h3 matLine>Correo electrónico</h3>
                <p matLine>
                    <span class="secondary-text">{{ contratista?.email }}</span>
                </p>
            </mat-list-item>

            <mat-list-item>
                <h3 matLine>Calificación</h3>
                <p matLine>
                    <app-star-rating
                        [seteable]="false"
                        [evaluacion]="contratista?.evaluacion"
                    ></app-star-rating>
                </p>
            </mat-list-item>
        </mat-list>
    </div>

    <!--<div
        fxFlex
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
        fxLayoutAlign="end end"
        style="height: 100%; width: 100%"
    >
        <button mat-raised-button color="accent" class="mt-16">Guardar</button>
    </div>-->
</div>
